/**
 * @module choices.js
 *
 * docs https://www.npmjs.com/package/choices.js
 */

import Choices from 'choices.js';

export default class SelectService {
    constructor(selectors = ['.choices'], options = {}) {
        this.selectors = selectors;
        this.options = {
            silent: true,
            searchEnabled: false,
            itemSelectText: '',
            ...options,
        };
    }

    init() {
        const findSelects = document.querySelectorAll(this.selectors);
        findSelects?.forEach((e) => new Choices(e, this.options));
    }
}
